import React, { forwardRef } from "react";
import SoftAvatarRoot from "./SoftAvatarRoot";
import { SxProps, Theme } from "@mui/material";

interface SoftAvatarProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  bgColor?:
    | "transparent"
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning"
    | "error"
    | "light"
    | "dark";
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
  shadow?: "none" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "inset";

  /** MUI Avatar props */
  variant?: "circular" | "rounded" | "square";

  /** MUI system props */
  sx?: SxProps<Theme>;
}

const SoftAvatar = forwardRef<HTMLImageElement, SoftAvatarProps>(
  (
    {
      bgColor = "transparent",
      size = "md",
      shadow = "none",
      variant = "circular",
      sx,
      ...rest
    },
    ref
  ) => (
    <SoftAvatarRoot
      ref={ref}
      ownerState={{ shadow, bgColor, size, variant }}
      sx={sx}
      {...rest}
    />
  )
);

SoftAvatar.displayName = "SoftAvatar";

export default SoftAvatar;
